<template>
    <el-form :model="forgotForm" ref="forgotForm"
             class="forgotForm md-layout md-alignment-center-center">
        <md-card class="md-layout-item">
            <md-card-header>
                <div class="md-title">Password Reset</div>
            </md-card-header>

            <div v-if="!reset_email_sent">
                <md-card-content>
                    <div class="md-layout">
                        <pre class="md-layout-item">Forgotten your password?
Enter your email address below, and we'll email instructions for setting a new one.
                        </pre>
                    </div>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                            <md-field id="email" :class="getValidationClass('email')">
                                <label for="email">Email address</label>
                                <md-input v-model="forgotForm.email"
                                          required
                                          name="email"
                                          type="text"
                                          @keyup.enter="SendResetEmail()"></md-input>
                                <span class="md-error"
                                      v-if="!$v.forgotForm.email.required">This field is required</span>
                                <span class="md-error" v-if="!$v.forgotForm.email.email">Should be a valid email</span>
                            </md-field>
                        </div>
                    </div>
                    <md-card-actions style="padding: 24px 16px 16px;">
                        <el-button class="md-primary md-raised md-layout-item md-alignment-center-center"
                                   @click="SendResetEmail()"
                                   :loading="sending_reset_email"
                                   type="primary"
                        >Reset password
                        </el-button>
                    </md-card-actions>
                </md-card-content>
            </div>

            <md-card-content v-if="reset_email_sent">
                <pre>We've emailed you instructions for setting your password.
You should receive the email shortly.
                </pre>
            </md-card-content>
        </md-card>
    </el-form>
</template>

<script>

    import {mapState} from "vuex";
    import {validationMixin} from 'vuelidate';
    import {required} from 'vuelidate/lib/validators';
    import {email} from '../utils/validators';

    export default {
        name: "ForgotPasswordView",
        mixins: [validationMixin],
        data() {
            return {
                forgotForm: {
                    email: ''
                }
            }
        },
        validations: {
            forgotForm: {
                email: {
                    required,
                    email
                }
            }
        },
        watch: {
            show_notification: function (newVal) {
                if (newVal === true) {
                    this.$notify({
                        title: this.notification['type'].charAt(0).toUpperCase() + this.notification['type'].slice(1),
                        message: this.notification['text'],
                        type: this.notification['type'],
                        position: 'top-right',
                    });
                }
            }
        },
        computed: {
            ...mapState({
                notification: state => state.auth.notification,
                show_notification: state => state.auth.show_notification,
                sending_reset_email: state => state.auth.sending_reset_email,
                reset_email_sent: state => state.auth.reset_email_sent,
            }),
        },
        methods: {
            SendResetEmail: function () {
                this.$v.$touch()
                if (this.$v.$invalid) return
                let payload = {
                    'email': this.forgotForm.email
                }
                console.log(payload);
                this.$store.dispatch('auth/forgotPassword', payload)
            },
            getValidationClass(fieldName) {
                const field = this.$v.forgotForm[fieldName]

                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty
                    }
                }
            }
        }
    };
</script>

<style scoped>
    form {
        display: inline-block;
        float: none;
        height: 200px;
        position: relative;
        top: 50%;
        -ms-transform: translateY(50%);
        transform: translateY(50%);
    }

    div.md-card-content {
        padding-left: 30px;
        padding-right: 30px;
    }
</style>